import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMcdonaldsComponent } from './simple-icons-mcdonalds.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMcdonaldsComponent ],
    exports:      [ SimpleIconsMcdonaldsComponent ],
    bootstrap:    []
})
export class SimpleIconsMcdonaldsModule {}
